// Local translations
export const T = {
  en_GB: {
    remove: "Remove",
    // Dialog
    editTitle: "Edit Asset Class",
    createTitle: "Add New Asset Class",
    editDescription: "Update the asset class information below.",
    createDescription: "Add a new asset class to categorize products in this collection.",
    // Form
    linkToInstrument: "Link to Instrument Database (Optional)",
    searchInstrument: "Search Instrument Database",
    linkHint: "Link to an instrument for reference or X-Ray analysis",
    name: "Name",
    namePlaceholder: "e.g., Equities, Fixed Income, Cash",
    statistics: "Statistics",
    copyFromApi: "Copy from API",
    loadingApi: "Loading API data...",
    statistic: "Statistic",
    apiValue: "API Value",
    storedValue: "Stored Value",
    expectedReturn: "Expected Return",
    expectedVolatility: "Expected Volatility",
    equityShare: "Equity Share",
    statsHintLinked: "Click 'Copy from API' to use API values. Modify as needed, then save.",
    statsHintManual:
      "Enter statistics values manually. Link to an instrument to fetch values from API.",
    // Errors
    somethingWentWrong: "Something went wrong",
    failedToSave: "Failed to save asset class",
    nameCannotContainSemicolon: 'Asset class name cannot contain ";"',
    failedToFetchStats: "Failed to fetch statistics",
    notLinkedError: "Asset class will NOT be linked to the database.",
    failedToFetchInstrument: "Failed to fetch instrument details.",
    // Actions
    cancel: "Cancel",
    save: "Save",
    addAssetClass: "Add Asset Class",
  },
  nb_NO: {
    remove: "Fjern",
    // Dialog
    editTitle: "Rediger aktivaklasse",
    createTitle: "Legg til ny aktivaklasse",
    editDescription: "Oppdater informasjonen om aktivaklassen nedenfor.",
    createDescription:
      "Legg til en ny aktivaklasse for å kategorisere produkter i denne samlingen.",
    // Form
    linkToInstrument: "Koble til instrumentdatabase (valgfritt)",
    searchInstrument: "Søk i instrumentdatabasen",
    linkHint: "Koble til et instrument for referanse eller X-Ray-analyse",
    name: "Navn",
    namePlaceholder: "f.eks. Aksjer, Obligasjoner, Kontanter",
    statistics: "Statistikk",
    copyFromApi: "Kopier fra API",
    loadingApi: "Laster API-data...",
    statistic: "Statistikk",
    apiValue: "API-verdi",
    storedValue: "Lagret verdi",
    expectedReturn: "Forventet avkastning",
    expectedVolatility: "Forventet volatilitet",
    equityShare: "Aksjeandel",
    statsHintLinked:
      "Klikk 'Kopier fra API' for å bruke API-verdier. Endre etter behov, deretter lagre.",
    statsHintManual:
      "Skriv inn statistikkverdier manuelt. Koble til et instrument for å hente verdier fra API.",
    // Errors
    somethingWentWrong: "Noe gikk galt",
    failedToSave: "Kunne ikke lagre aktivaklasse",
    nameCannotContainSemicolon: 'Navnet på aktivaklassen kan ikke inneholde ";"',
    failedToFetchStats: "Kunne ikke hente statistikk",
    notLinkedError: "Aktivaklassen vil IKKE bli koblet til databasen.",
    failedToFetchInstrument: "Kunne ikke hente instrumentdetaljer.",
    // Actions
    cancel: "Avbryt",
    save: "Lagre",
    addAssetClass: "Legg til aktivaklasse",
  },
} as const;
